import * as t from "../actions";
var moment = require("moment-timezone");

const initialScheduleState: any = {
  type: "daily",
  day: "1",
  timezone: "America/New_York",
  // desired time is 7am EST/EDT (or -5/-4 UTC)
  time: moment.tz(moment.tz("UTC").startOf("day").hour(11), "America/New_York"),
  start: moment("00:00:00", "HH:mm:ss"),
  enabled: true
};

export default function (state = initialScheduleState, action: any) {
  switch (action.type) {
    case t.TOGGLE_DAILY:
      return {
        ...state,
        type: "daily"
      };

    case t.TOGGLE_WEEKLY:
      return {
        ...state,
        type: "weekly"
      };

    case t.TOGGLE_MONTHLY:
      return {
        ...state,
        type: "monthly"
      };

    case t.EDIT_DAY:
      return {
        ...state,
        day: action.payload
      };

    case t.EDIT_TIME:
      return {
        ...state,
        time: action.payload
      };

    case t.EDIT_TIMEZONE:
      return {
        ...state,
        timezone: action.payload,
        time: moment.tz(state.time, action.payload)
      };

    case t.EDIT_START:
      return {
        ...state,
        start: action.payload
      };

    case t.TOGGLE_ENABLED:
      return {
        ...state,
        enabled: !state.enabled
      };

    case t.ADD_REPORT:
      const dayFromFrequency = (action: any) => {
        const {
          payload,
          payload: { frequency }
        } = action;
        if (frequency == "monthly") return payload.day_of_month;
        else if (frequency == "weekly") return payload.day_of_week;
        else return 1;
      };
      return {
        type: action.payload.frequency,
        day: `${dayFromFrequency(action)}`,
        time: moment.tz(action.payload.start_time, action.payload.timezone),
        timezone: action.payload.timezone,
        start: moment(action.payload.start_date),
        enabled: action.payload.enabled
      };

    case t.FLUSH_REPORT:
      return initialScheduleState;

    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./client/modules/ReportForm/reducer/schedule.ts